import { connect } from 'react-redux';

import ReportSelection from '../../components/Reports/ReportSelection';
import { selectReportTypeName } from '../../actions/areas/reports';

const mapStateToProps = ({ areas: { reports } }) => ({
  selectedReportTypeName: reports.reportSelection.selectedReportTypeName,
});

const mapDispatchToProps = dispatch => ({
  selectReportTypeName: type => dispatch(selectReportTypeName(type)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
});

const ReportSelectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ReportSelection);

export default ReportSelectionContainer;
